import { AuthCallback } from './pages';

export default {
  key: 'auth-callback',
  isPrivate: false,
  exact: true,
  path: '/users/callback',
  component: AuthCallback,
};
